import {useStore} from 'zustand';
import {useShallow} from 'zustand/react/shallow';

import {useDocumentContext} from '../context/use-document-context';
import {DocumentStore, DocumentStoreApi} from './document-store';

export const useDocumentStore = <U,>(selector: (state: DocumentStore) => U) => {
  const {store} = useDocumentContext();

  return useStore<DocumentStoreApi, U>(store, useShallow(selector));
};
